module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"departure":"Depuis","arrival":"Vers","errors":{"departure-airport-required":"Le lieu de départ est requis","arrival-airport-required":"Le lieu de retour est requis"}},"en":{"departure":"From","arrival":"To","errors":{"departure-airport-required":"Departure place is required","arrival-airport-required":"Arrival place is required"}}}')
  delete Component.options._Ctor
}
